<div class="w-full px-6 py-4 md:px-8 md:py-5 flex items-center justify-between border-b border-dark-khaki-200 dark:border-vivid-royal-800 bg-white dark:bg-vivid-royal-950">
    <h1 class="text-lg md:text-2xl font-semibold text-vivid-royal-800 dark:text-vivid-royal-100 truncate">{{title}}</h1>
    <div class="hidden md:flex items-center gap-4">
       
        <button (click)="this.hiddenNotifications=false;" class="text-vivid-royal-400 hover:text-vivid-royal-600 dark:text-vivid-royal-300 dark:hover:text-white transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
        </button>
        @if(!hiddenNotifications){
            <app-notification-center (onClose)="showNotifications()"></app-notification-center>
        }
    </div>
</div>
